import * as CONSTANTS from './constants';

export const fetchGoogleLoginUrlRequest = (companyId) => ({
  type: CONSTANTS.FETCH_GOOGLE_LOGIN_URL_REQUEST,  
  companyId
});

export const fetchGoogleLoginUrlSuccess = (data) => ({
  type: CONSTANTS.FETCH_GOOGLE_LOGIN_URL_SUCCESS,
  data,
});

export const fetchGoogleLoginUrlFail = (error) => ({
  type: CONSTANTS.FETCH_GOOGLE_LOGIN_URL_FAIL,
  error,
});

export const fetchCompanyDetailRequest = (id) => ({
  type: CONSTANTS.FETCH_COMPANY_DETAIL_REQUEST,
  id,
});

export const fetchCompanyDetailSuccess = (data) => ({
  type: CONSTANTS.FETCH_COMPANY_DETAIL_SUCCESS,
  data,
});

export const fetchCompanyDetailFail = (error) => ({
  type: CONSTANTS.FETCH_COMPANY_DETAIL_FAIL,
  error,
});
